import React from "react";
import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, ArrowLeft, Settings } from "lucide-react";
import BrandMark from "@/components/app/BrandMark";

export default function WorkerLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isRoot = location.pathname === "/worker";

  const doLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between">
          {isRoot ? (
            <BrandMark size="md" tone="dark" />
          ) : (
            <button
              onClick={() => navigate(-1)}
              data-testid="worker-back-btn"
              className="flex items-center gap-1 text-sm font-medium text-slate-700"
            >
              <ArrowLeft className="h-5 w-5" />
              Back
            </button>
          )}
          {user?.role === "manager" ? (
            <Link
              to="/dashboard"
              data-testid="worker-to-dashboard-link"
              className="text-xs font-bold uppercase tracking-wider text-slate-500"
            >
              Dashboard
            </Link>
          ) : (
            <div className="flex items-center gap-3">
              <Link
                to="/worker/account"
                data-testid="worker-account-link"
                className="text-slate-500"
                aria-label="Account settings"
              >
                <Settings className="h-4 w-4" />
              </Link>
              <button
                onClick={doLogout}
                data-testid="worker-logout-btn"
                className="text-xs font-bold uppercase tracking-wider text-slate-500 flex items-center gap-1"
              >
                <LogOut className="h-4 w-4" />
                Sign out
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="flex-1 w-full">
        <div className="max-w-md mx-auto p-4 sm:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
